function getDynamicHeight() {
  const supportsDVH = CSS.supports('height', '100dvh');

  if (supportsDVH) {
    return `calc(100dvh - env(safe-area-inset-bottom, 0px) - env(safe-area-inset-top, 0px))`;
  } else {
    return `calc(100vh - env(safe-area-inset-bottom, 0px) - env(safe-area-inset-top, 0px))`;
  }
}

function getDynamicWidth() {
  const supportsDVH = CSS.supports('width', '100dvw');
  if (supportsDVH) {
    return `calc(100dvw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px))`;
  } else {
    return `calc(100vw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px))`;
  }
}

export const MAX_PAGE_HEIGHT = getDynamicHeight();
export const MAX_PAGE_WIDTH = getDynamicWidth(); //'1200px';
export const MENU_WIDTH = '200px';
export const HEADER_HEIGHT = '64px';
export const FOOTER_HEIGHT = '64px';
export const WEB_CONTENT_WIDTH = `calc(min(960px, calc(${MAX_PAGE_WIDTH} - ${MENU_WIDTH} - 8px)))`;
export const PAGE_CONTAINER_HEADER_HEIGHT = '64px';
export const HEADER_SPACE_HEIGHT = '0px'; //'8px'; divider on page container
export const MAX_CONTENT_HEIGHT = `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${PAGE_CONTAINER_HEADER_HEIGHT} - ${HEADER_SPACE_HEIGHT})`;
export const MAX_MOBILE_CONTENT_HEIGHT = `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT})`;
export const TABS_HEAIGHT = '44px';

export const SEARCH_FIELD_BOX = '44px';
export const SEARCH_FIELD_BOX_MARGIN_TOP = '8px';
export const SEARCH_FIELD_BOX_HEIGHT = '52px';
export const SEARCH_FIELD_BOX_PADDING = '8px';
export const LIST_PADDING = '8px';
export const LIST_TOP_MARGIN = '8px';
export const SAFE_LIST_AREA_HEIGHT = '4px';

export const breakpointValues = {
  values: {
    xs: 0,
    sm: 420,
    md: 768,
    lg: 1024,
    xl: 1280,
  },
};
